import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import dayjs from "dayjs";
import { data } from "../data";
import axios from "axios";
import { getPracticeId } from "../../config/practice";

const PelvicView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

    const fetchData = async () => {
      try {
   const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/v1/${getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );
      
      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        setExamData(parsedData);
      }
      } catch (error) {
        console.error("Error fetching exam data:", error);
      }
    };
  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);

  return (
<div
  id={examData ? "report-ready" : undefined}
  className="p-6 bg-white min-h-screen w-full flex justify-center items-center"
>
  <div className="w-full max-w-3xl flex flex-col items-center border border-gray-300 rounded-md p-12 shadow-sm">
        {/* Header */}
        <div className="flex items-start w-full justify-center mb-6">
          <img src={BrianyCareLogo} alt="Logo" className="w-14 h-14 mr-3" />
          <div>
            <h1 className="text-xl font-bold text-blue-600 leading-none">C-HIM</h1>
            <p className="text-sm font-semibold mt-1">Center for Hypertension & Internal Medicine</p>
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center font-bold text-base underline mb-4">Pelvic ULTRASOUND</h2>

        {examData ? (
          <>
            <div className="flex justify-start text-sm text-left w-full mb-4">
                                <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                                  <span><strong>MR No#</strong></span>
                                  <span>:</span>
                                  <span>{examData.patient_id}</span>
                              
                                  <span><strong>Name</strong></span>
                                  <span>:</span>
                                  <span>{examData.pat_name}</span>
                              
                                  <span><strong>Age</strong></span>
                                  <span>:</span>
                                  <span>{examData.pat_age}</span>
                              
                                  <span><strong>Exam Date</strong></span>
                                  <span>:</span>
                                  <span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                              
                                  <span><strong>Date of Birth</strong></span>
                                  <span>:</span>
                                  <span>{dayjs(examData.pat_dob).format("MMM D, YYYY")}</span>
                              
                                  <span><strong>Provider</strong></span>
                                  <span>:</span>
                                  <span>{examData.providername}</span>
                              
                                  
                              
                                  <span><strong>Patients History</strong></span>
                                  <span>:</span>
                                  <span>{examData.history}</span>
                                </div>
                              </div>
<div className="text-sm text-left w-full space-y-4">


  {/* Uterus */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Uterus:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LONG: {examData.uterus?.LONG || "N/A"} {examData.uterus?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.uterus?.AP || "N/A"} {examData.uterus?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.uterus?.TRANS || "N/A"} {examData.uterus?.unit || ""}</span>
    </div>
  </div>

  {/* Right Ovary */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Right Ovary:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LONG: {examData.rtOvary?.LONG || "N/A"} {examData.rtOvary?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.rtOvary?.AP || "N/A"} {examData.rtOvary?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.rtOvary?.TRANS || "N/A"} {examData.rtOvary?.unit || ""}</span>
    </div>
  </div>

  {/* Right Cyst/Mass */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Right Cyst/Mass:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LC: {examData.rtCystMass?.LC || "N/A"} {examData.rtCystMass?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.rtCystMass?.AP || "N/A"} {examData.rtCystMass?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.rtCystMass?.TRANS || "N/A"} {examData.rtCystMass?.unit || ""}</span>
    </div>
    {examData.rtCystMassComment && (
      <div className="mt-1 ml-4 text-gray-600 italic text-xs">{examData.rtCystMassComment}</div>
    )}
  </div>

  {/* Left Ovary */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Left Ovary:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LONG: {examData.ltOvary?.LONG || "N/A"} {examData.ltOvary?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.ltOvary?.AP || "N/A"} {examData.ltOvary?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.ltOvary?.TRANS || "N/A"} {examData.ltOvary?.unit || ""}</span>
    </div>
  </div>

  {/* Left Cyst/Mass */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Left Cyst/Mass:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LC: {examData.ltCystMass?.LC || "N/A"} {examData.ltCystMass?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.ltCystMass?.AP || "N/A"} {examData.ltCystMass?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.ltCystMass?.TRANS || "N/A"} {examData.ltCystMass?.unit || ""}</span>
    </div>
    {examData.ltCystMassComment && (
      <div className="mt-1 ml-4 text-gray-600 italic text-xs">{examData.ltCystMassComment}</div>
    )}
  </div>

  {/* Fibroid */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Fibroid:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">LONG: {examData.fibroid?.LONG || "N/A"} {examData.fibroid?.unit || ""}</span>
      <span className="text-gray-700">AP: {examData.fibroid?.AP || "N/A"} {examData.fibroid?.unit || ""}</span>
      <span className="text-gray-700">TRANS: {examData.fibroid?.TRANS || "N/A"} {examData.fibroid?.unit || ""}</span>
    </div>
    {examData.fibroidComment && (
      <div className="mt-1 ml-4 text-gray-600 italic text-xs">{examData.fibroidComment}</div>
    )}
  </div>

  {/* Uterine Position */}
  <div className="flex items-center space-x-2 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900 w-32">Uterine Position:</strong>
    <span className="text-gray-700">{examData.position || "N/A"}</span>
  </div>

  {/* Endometrium */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Endometrium:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">Thickness: {examData.endometrium?.value || "N/A"} {examData.endometrium?.unit || ""}</span>
      <span className="text-gray-700">Fluid: {examData.endometrium?.fluid || "N/A"}</span>
      <span className="text-gray-700">Mass: {examData.endometrium?.mass || "N/A"}</span>
    </div>
  </div>

  {/* Cul-de-Sac */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Cul-de-Sac:</strong>
    <div className="flex space-x-4">
      <span className="text-gray-700">Net: {examData.culDeSac?.net || "N/A"}</span>
      <span className="text-gray-700">Fluid: {examData.culDeSac?.fluid || "N/A"}</span>
    </div>
  </div>

  {/* LMP */}
  <div className="flex items-center space-x-2 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900 w-32">LMP:</strong>
    <span className="text-gray-700">{examData.lmp || "N/A"}</span>
  </div>

  {/* Hormone Replacement */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Hormone Replacement:</strong>
    <div>
      <span className="text-gray-700">{examData.hormoneReplacement ? "Yes" : "No"}</span>
      {examData.hormoneReplacementComment && (
        <div className="mt-1 ml-4 text-gray-600 italic text-xs">{examData.hormoneReplacementComment}</div>
      )}
    </div>
  </div>

  {/* Birth Control */}
  <div className="flex flex-col space-y-1 hover:bg-gray-50 p-2 rounded-md transition">
    <strong className="font-medium text-gray-900">Birth Control:</strong>
    <div>
      <span className="text-gray-700">{examData.birthControl ? "Yes" : "No"}</span>
      {examData.birthControlComment && (
        <div className="mt-1 ml-4 text-gray-600 italic text-xs">{examData.birthControlComment}</div>
      )}
    </div>
  </div>
</div>

           

       

                      {/* Signature */}
          <div className="flex justify-end w-full">
      <div className="relative flex border p-2 min-w-[350px] max-w-full">
  {/* Left Side - Signature */}
  <div className="w-1/2 pr-4 break-words whitespace-pre-wrap z-10">
    <div className="font-semibold">
      {examData.signature}
    </div>
  </div>

  {/* Divider */}
  <div className="absolute top-0 bottom-0 left-1/2 w-px bg-gray-300" />

  {/* Right Side - Signer Info */}
  <div className="w-1/2 pl-4 text-sm text-left z-10">
    <div>Digitally Signed by</div>
    <div>{examData?.createdby || ''}</div>
    <div>{dayjs(examData.dateofservice).format("MM-DD-YYYY")}</div>
  </div>
</div>

     </div>
          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default PelvicView;
